<template>
  <el-dialog
    :title="dtitle"
    :visible="dialogFormVisible"
    :before-close="handleClose"
    class="dialog-form"
    width="60%"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="formData"
      :disable="true"
    ></table-form>
    <div class="upload">
      <el-table :data="dataUp" style="width: 100%" border>
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column
          prop="title"
          label="材料名称"
          min-width="150"
        ></el-table-column>
        <el-table-column
          prop="oldFile"
          label="附件名称"
          width="auto"
        ></el-table-column>
        <el-table-column label="下载附件" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.newFile ? false : true"
              @click="downFile(scope.row)"
              style="font-size:14px"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sure">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm";
import { step3 } from "@/conf/newAgency";
import {
  getInvestorDetail,
  institutionDownLoadCommon,
  downLoadCommon,
  financeLinkmanDetail,
  getLegalDetail,
  personInfoDetail,
} from "common/js/api";
export default {
  components: {
    TableForm,
  },

  props: ["dialogVisible", "dtitle", "tableData", "dataSource", "isAgency"], //falg判断是联系人、负责人

  data() {
    return {
      dialogFormVisible: false,
      formData: {},
      dataUp: [],
    };
  },
  methods: {
    async downFile(row) {
      // const fileData = row.newFile.split("/");
      // const suffix = fileData[1].split(".");

      // const fileData = row.newFile.split("/");
      //       const index = row.newFile.lastIndexOf("/");
      //       const suffix = row.newFile.slice(index + 1).split(".");
      //       const filePath = row.newFile.slice(0, index);
      // console.log(filePath, suffix[1], row.oldFile, suffix[0]);

      //       await downLoadCommon(filePath, suffix[1], row.oldFile, suffix[0]);

      const filePath = row.newFile;
      const fileName = row.oldFile;
      console.log("@@row", row);
      console.log("@@filePath", filePath);
      console.log("@@fileName", fileName);
      const params = {
        filePath: filePath,
        fileName: fileName,
      };
      await institutionDownLoadCommon(params);

      // await downLoadCommon(fileData[0], suffix[1], row.oldFile, suffix[0]);
    },
    // handleSure() {
    //   this.dialogFormVisible = false;
    //   this.$emit("closeDialog");
    // },
    handleClose() {
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    },
    sure() {
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    },
    async setInvestor(id) {
      const { result } = await getInvestorDetail(id);

      this.formData = result;
      this.formData.qualified = this.formData.qualified?"1":"0";
      this.dataUp = [];
      this.dataUp = [
        {
          title: "出资人登记承诺书",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "学位/学历材料",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "出资能力佐证材料",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "营业执照/身份证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "简介",
          oldFile: "--",
          newFile: "",
        },
      ];
      this.dataUp[0].oldFile = this.formData.promiseOrignName;
      this.dataUp[0].newFile = this.formData.promiseStorePath;
      this.dataUp[1].oldFile = this.formData.degreeOrignName;
      this.dataUp[1].newFile = this.formData.degreeStorePath;
      this.dataUp[2].oldFile = this.formData.qualifiedInvestorFileOrignName;
      this.dataUp[2].newFile = this.formData.qualifiedInvestorFileStorePath;
      this.dataUp[3].oldFile = this.formData.identityFileOrignName;
      this.dataUp[3].newFile = this.formData.identityFileStorePath;
      this.dataUp[4].oldFile = this.formData.qualifiedEvidOrignName;
      this.dataUp[4].newFile = this.formData.qualifiedEvidStorePath;
      if (result.institutionCode.slice(0, 2) != "GL") {
        this.dataUp.push({
          title: "合格投资者证明",
          oldFile: result.qualifiedInvestorFileOrignName,
          newFile: result.qualifiedInvestorFileStorePath,
        });
      }
    },
    // 实际控制人信息
    async setLink(id) {
      const { result } = await personInfoDetail(id);

      this.formData = result;
      this.dataUp = [];
      this.dataUp = [
        {
          title: "营业执照/身份证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "学位/学历材料",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "管理人之间的控制关系图",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "简介",
          oldFile: "--",
          newFile: "",
        },
      ];
      if (this.formData.identifyCardStorePath) {
        this.dataUp[0].oldFile = this.formData.identifyCardOrignName;
      }
      this.dataUp[0].newFile = this.formData.identifyCardStorePath;
      //学位/学历材料
      if (this.formData.degreeFileStorePath) {
        this.dataUp[1].oldFile = this.formData.degreeFileOrignName;
      }
      this.dataUp[1].newFile = this.formData.degreeFileStorePath;
      // 管理人之间的控制关系图
      if (this.formData.controllerRelationStorePath) {
        this.dataUp[2].oldFile = this.formData.controllerRelationOrignName;
      }
      this.dataUp[2].newFile = this.formData.controllerRelationStorePath;
      // 简介
      if (this.formData.abstractInfoStorePath) {
        this.dataUp[3].oldFile = this.formData.abstractInfoOrignName;
      }
      this.dataUp[3].newFile = this.formData.abstractInfoStorePath;
    },
    //设置法人信息
    async setLegal1(id) {
      const { result } = await personInfoDetail(id);
      this.formData = result;
      this.dataUp = [
        {
          title: "身份证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "简历",
          oldFile: "--",
          newFile: "",
        },
      ];
      if (this.formData.identifyCardStorePath) {
        this.dataUp[0].oldFile = this.formData.identifyCardOrignName;
      }
      this.dataUp[0].newFile = this.formData.identifyCardStorePath;
      if (this.formData.abstractInfoStorePath) {
        this.dataUp[1].oldFile = this.formData.abstractInfoOrignName;
      }
      this.dataUp[1].newFile = this.formData.abstractInfoStorePath;
    },
    //高级管理人信息
    async setLegal(id) {
      const { result } = await personInfoDetail(id);
      this.formData = result;
      this.dataUp = [
        {
          title: "身份证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "学位/学历材料",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "基金从业资格证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "简历",
          oldFile: "--",
          newFile: "",
        },
      ];
      console.log( "common-dialog组件--后台根据id查询高级管理人(setLegal(id))--查询到的信息this.formData",JSON.stringify(this.formData));
      console.log( "common-dialog组件--后台根据id查询高级管理人(setLegal(id))--this.formData.qualification",this.formData.qualification);
      if (this.formData.qualification == 0) {
        this.formData.qualification = "0";
      }
      if (this.formData.qualification == 1) {
        this.formData.qualification = "1";
      }
      if (this.formData.identifyCardStorePath) {
        this.dataUp[0].oldFile = this.formData.identifyCardOrignName;
      }
      this.dataUp[0].newFile = this.formData.identifyCardStorePath;
      if (this.formData.degreeFileStorePath) {
        this.dataUp[1].oldFile = this.formData.degreeFileOrignName;
      }
      this.dataUp[1].newFile = this.formData.degreeFileStorePath;
      if (this.formData.qualificationStorePath) {
        this.dataUp[2].oldFile = this.formData.qualificationOrignName;
      }
      this.dataUp[2].newFile = this.formData.qualificationStorePath;
      if (this.formData.abstractInfoStorePath) {
        this.dataUp[3].oldFile = this.formData.abstractInfoOrignName;
      }
      this.dataUp[3].newFile = this.formData.abstractInfoStorePath;
    },


    setDownLoad(id) {
      if (this.dtitle.includes("出资人")) {
        this.setInvestor(id);
      } else if (["实际控制人详情"].includes(this.dtitle)) {
        this.setLink(id);
      } else if (["高级管理人详情"].includes(this.dtitle)) {
        this.setLegal(id);
      } else if (["法定代表人详情"].includes(this.dtitle)) {
        this.setLegal1(id);
      }
    },
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    },
    tableData: {
      handler(newValue) {
        console.log("common-dialog组件--watch方法中更改tableData触发--newValue",newValue);
        // this.formData = newValue;
        //formData通过id查出来了
        console.log("common-dialog组件--watch方法中--formData",this.formData);
        this.setDownLoad(newValue.id);
      },
      deep: true,
    },
  },
};
</script>

